export default "__VITE_ASSET__qQB6Ev9k__"